import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { BaseDialog, Dialog } from '@lf-web-components/lf-dialog-library';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EventSystemService } from '@lf-web-components/lf-event-library';
import { lfFilesetLocalize } from '../shared/utils';
import { ImportMode } from '../shared/fs.model';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
  selector: 'lf-import-picker-dialog',
  templateUrl: './import-picker-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./import-picker-dialog.component.css', '../global-styles.css', '../lf-button-styles.css', '../lf-custom-mat-styles.css']
})
@Dialog({
  name: 'ImportPickerDialog',
  width: '400px',
  height: '300px',
  dialogConfig: {
    panelClass: 'lf-import-picker-dialog',
    scrollStrategy: new NoopScrollStrategy()
  }
})
export class ImportPickerDialogComponent extends BaseDialog implements OnInit {
  lfFilesetLocalizeHelper = lfFilesetLocalize;

  constructor(eventSystem: EventSystemService,
    dialogRef: MatDialogRef<BaseDialog>,
    @Inject(MAT_DIALOG_DATA) protected data: any) { 
    super(eventSystem, dialogRef, data);
  }

  ngOnInit() {

  }

  get local(): ImportMode {
    return ImportMode.Local;
  }

  get repo(): ImportMode {
    return ImportMode.Repository;
  }

  onClose(){
    this.dialogRef.close();
  }
  
  onSelectImport(option: ImportMode) {
    this.dialogRef.close(option);
  }
}